import toast from 'react-hot-toast';


// 뉴스 URL 복사 문구
export const pasteURL = () => {
    const config = {
        position: 'top-leftr',
    }
    toast('URL이 복사되었습니다.', config);
}